import React from 'react';
import {
    MdExpandMore,
    MdAccountCircle,
    MdSettings,
    MdHelpOutline,
    MdLogout
} from 'react-icons/md';
import styles from './SideBar.module.css';

const UserSection = ({
    user,
    isOpen,
    showUserMenu,
    onToggleMenu,
    onLogoutClick,
    userMenuRef
}) => {
    return (
        <div className={styles.userSection} ref={userMenuRef}>
            <button
                className={`${styles.userCard} ${showUserMenu ? styles.active : ''}`}
                onClick={onToggleMenu}
            >
                <div className={styles.userAvatar}>
                    {user?.fullName?.charAt(0)?.toUpperCase() || 'A'}
                </div>
                {isOpen && (
                    <>
                        <div className={styles.userInfo}>
                            <div className={styles.userName}>{user?.fullName || ''}</div>
                            <div className={styles.userEmail}>
                                {user?.email || 'admin@SclinEDC.com'}
                            </div>
                        </div>
                        <MdExpandMore className={`${styles.expandIcon} ${showUserMenu ? styles.expanded : ''}`} />
                    </>
                )}
            </button>

            {showUserMenu && isOpen && (
                <div className={styles.userDropdown}>
                    {/* <button className={styles.userMenuItem}>
                        <MdAccountCircle className={styles.userMenuIcon} />
                        <span>My Profile</span>
                    </button>
                    <button className={styles.userMenuItem}>
                        <MdSettings className={styles.userMenuIcon} />
                        <span>Settings</span>
                    </button>
                    <button className={styles.userMenuItem}>
                        <MdHelpOutline className={styles.userMenuIcon} />
                        <span>Help</span>
                    </button>
                    <div className={styles.userMenuDivider} /> */}
                    <button
                        className={`${styles.userMenuItem} ${styles.danger}`}
                        onClick={onLogoutClick}
                    >
                        <MdLogout className={styles.userMenuIcon} />
                        <span>Sign Out</span>
                    </button>
                </div>
            )}
        </div>
    );
};

export default UserSection;